import React, { useState, useEffect, useRef, useCallback } from 'react';

import { Button } from '@material-ui/core';
import { Add, Remove, Refresh } from '@material-ui/icons';

import { isEmpty, differenceBy, findIndex, isNull, first, filter, isUndefined } from 'lodash';

import PropTypes from 'prop-types';

import { Tooltip, IconButton } from '@material-ui/core';
import {
    createMuiTheme,
    MuiThemeProvider,
} from "@material-ui/core/styles";
import { Info } from '@material-ui/icons';

import { Modal } from '~/components';
import { t } from '~/helpers';

import { MDate, MTable, Table } from './components';
import * as S from './styles';

const theme = createMuiTheme({
    overrides: {
        MuiTooltip: {
            tooltip: {
                fontSize: "1.4rem",
            },
        }
    }
});

export default function CustomSelectDataInTable({
    date,
    time,
    height,
    cells,
    size,
    onChanged,
    title,
    showCount,
    paginate,
    unique,
    items,
    label,
    disablePreviousDate,
    disableFutureDate,
    initials,
    fields,
    onField,
    schema,
    isIgnore,
    position,
    maxWidth,
    titleModal,
    checkbox,
    radio,
    create,
    remove,
    icons,
    variant,
    showPagination,
    onCallback,
    noCreate,
    noRemove,
    onRow,
    loading,
    onOpenForm,
    userPerfil,
}) {
    const [data, setData] = useState(initials);
    const [head, setHead] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const [selected, setSelected] = useState([]);
    const [editorProfile, setEditorProfile] = useState({ perfil_cad: null })
    const [disableActions, setDisableActions] = useState(false)

    const tableRef = useRef(null);

    const handleOpenModal = useCallback(
        (params) => {
            if (isEmpty(fields)) {
                if (date) setIsOpen(true);
                else tableRef.current.handleOpenModal();
            } else {
                tableRef.current.handleOpenModal({ initials: params });
                onOpenForm(params)
            }
        },
        [date, fields]
    );

    const handleAddDateTime = useCallback((isDate) => {
        setData((state) => [...state, { date: isDate }]);
    }, []);

    const handleAddItem = useCallback((value) => {
        setData((state) => [...state, {
            ...value,
            perfil_cad: userPerfil.glousuariologin,
            perfil_tipo: userPerfil.perf_tipo,
            perfil_desc: userPerfil.appperfilusuario
        }]);
        tableRef.current.handleCloseModal();
    }, [userPerfil]);

    const handleModifyItem = useCallback(
        (value) => {
            const key = findIndex(data, (d) => d[unique] === value[unique]);

            setData((state) =>
                state.map((rest, index) => {
                    if (index === key) return {
                        ...value,
                        perfil_cad: userPerfil.glousuariologin,
                        perfil_tipo: userPerfil.perf_tipo,
                        perfil_desc: userPerfil.appperfilusuario
                    };
                    return rest;
                })
            );

            tableRef.current.handleCloseModal();
            setSelected([]);
        },
        [data, unique, userPerfil]
    );

    const handleSelectItems = useCallback((values) => {
        setSelected(values);
    }, []);

    const handleRemoveItems = useCallback(() => {
        onCallback({ type: 'remove', data: selected });
        setData((state) => differenceBy(state, selected, unique));
        setSelected([]);
    }, [selected, unique]);

    useEffect(() => {
        if (!isEmpty(cells) && !date) setHead(cells);
        if (date) setHead([{ id: 'date', label: 'Data' }]);
    }, [cells, date]);

    useEffect(() => {
        onChanged(data);
    }, [data]);

    useEffect(() => {


        
            let isBlocked;
            let obj = filter(initials, { perfil_tipo: '2' });
            if (!isEmpty(obj)) {
              const isTimeBlock = first(obj);
              isBlocked = !isUndefined(isTimeBlock) && !isNull(isTimeBlock.perfil_cad) && isTimeBlock.perfil_tipo != 1 && (userPerfil.perf_tipo == 1 || isTimeBlock.perfil_tipo < userPerfil.perf_tipo);
              handleCheckProfile({ disable: isBlocked , ...isTimeBlock});
            } else {
              obj = filter(initials, { perfil_tipo: '3' });
              if (!isEmpty(obj)) {
                const isTimeBlock = first(obj);
                isBlocked = !isUndefined(isTimeBlock) && !isNull(isTimeBlock.perfil_cad) && isTimeBlock.perfil_tipo != 1 && (userPerfil.perf_tipo == 1 || isTimeBlock.perfil_tipo < userPerfil.perf_tipo);
                handleCheckProfile({ disable: isBlocked , ...isTimeBlock});
              }  else {
                obj = filter(initials, { perfil_tipo: '4' });
                if (!isEmpty(obj)) {
                  const isTimeBlock = first(obj);
                  isBlocked = !isUndefined(isTimeBlock) && !isNull(isTimeBlock.perfil_cad) && isTimeBlock.perfil_tipo != 1 && (userPerfil.perf_tipo == 1 || isTimeBlock.perfil_tipo < userPerfil.perf_tipo);
                  handleCheckProfile({ disable: isBlocked , ...isTimeBlock});
                } 
              }
            }
       


        setData(initials);
    }, [initials]);


    const handleCheckProfile = useCallback((values) => {
        setDisableActions(values.disable)
        setEditorProfile(values)
    }, [])

    return (
        <>
            <S.Wrapper position={position}>
                <MuiThemeProvider theme={theme}>
                    <S.infoWrapper>
                        <S.iconWrapper>
                            <Tooltip placement="left-end"
                                title={`Alterado por: ${editorProfile.perfil_desc} `}>
                                <IconButton style={{ padding: 2 }} disabled={isNull(editorProfile.perfil_cad) || editorProfile.perfil_cad == 'null'}>
                                    <Info style={{ height: '20px', width: '20px' }} color={isNull(editorProfile.perfil_cad) || editorProfile.perfil_cad == 'null' ? "#000000de" : "secondary"} />
                                </IconButton>
                            </Tooltip>
                        </S.iconWrapper>

                    </S.infoWrapper>
                </MuiThemeProvider>
                <S.GroupButtons position={position}>
                    {create && !noCreate && (
                        <Button
                            color="primary"
                            variant={variant}
                            size="small"
                            startIcon={icons ? <Add /> : undefined}
                            onClick={() => handleOpenModal({})}
                            disabled={loading || disableActions} 
                        >
                            {t('s.geral.botaoincluir')}
                        </Button>
                    )}

                    {!isEmpty(fields) && (
                        <Button
                            color="primary"
                            variant={variant}
                            size="small"
                            startIcon={icons ? <Refresh /> : undefined}
                            disabled={selected.length !== 1 || loading || disableActions}
                            onClick={() => handleOpenModal(selected[0])}
                        >
                            {t('s.geral.botaoatualizar')}
                        </Button>
                    )}

                    {remove && !noRemove && (
                        <Button
                            color="secondary"
                            variant={variant}
                            size="small"
                            startIcon={icons ? <Remove /> : undefined}
                            disabled={isEmpty(selected) || loading || disableActions}
                            onClick={handleRemoveItems}
                        >
                            {t('s.geral.botaoexcluir')}
                        </Button>
                    )}
                </S.GroupButtons>

                <Table
                    showPagination={showPagination}
                    checkbox={checkbox && !radio}
                    radio={radio}
                    noButton
                    cells={head}
                    data={data}
                    clearCheckeds={isEmpty(selected)}
                    height={`${height}rem`}
                    size={size}
                    title={title}
                    showCount={showCount}
                    paginate={paginate}
                    unique={unique}
                    onCallback={handleSelectItems}
                    onRow={onRow}
                    tipoPerfil={userPerfil.perf_tipo}
                    checkProfile={handleCheckProfile}
                />
            </S.Wrapper>

            <MDate
                time={time}
                open={isOpen}
                onClose={setIsOpen}
                onSubmit={handleAddDateTime}
                items={data}
                disablePreviousDate={disablePreviousDate}
                disableFutureDate={disableFutureDate}
            />

            <Modal
                ref={tableRef}
                form
                disableBackdropClick
                disableEscapeKeyDown
                maxWidth={maxWidth}
                title={titleModal}
                component={(props) => (
                    <MTable
                        {...props}
                        items={items}
                        ignore={data}
                        onChangeItem={handleAddItem}
                        onModify={handleModifyItem}
                        label={label}
                        fields={fields}
                        onField={onField}
                        isSchema={schema}
                        isIgnore={isIgnore}
                        onCallback={onCallback}
                    />
                )}
            />
        </>
    );
}

CustomSelectDataInTable.propTypes = {
    date: PropTypes.bool,
    time: PropTypes.bool,
    height: PropTypes.number,
    cells: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
            format: PropTypes.func,
        })
    ).isRequired,
    size: PropTypes.oneOf(['small', 'medium']),
    onChanged: PropTypes.func.isRequired,
    title: PropTypes.string,
    showCount: PropTypes.bool,
    paginate: PropTypes.number,
    unique: PropTypes.string,
    items: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.oneOfType(PropTypes.string, PropTypes.number).isRequired,
            label: PropTypes.string.isRequired,
            value: PropTypes.oneOfType(PropTypes.string, PropTypes.number).isRequired,
        })
    ),
    label: PropTypes.string,
    disablePreviousDate: PropTypes.bool,
    disableFutureDate: PropTypes.bool,
    initials: PropTypes.arrayOf(PropTypes.any),
    fields: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
            type: PropTypes.string.isRequired,
            options: PropTypes.arrayOf(),
            disabled: PropTypes.bool,
        })
    ),
    onField: PropTypes.func,
    schema: PropTypes.objectOf(PropTypes.any),
    isIgnore: PropTypes.string,
    position: PropTypes.oneOf(['row', 'column']),
    maxWidth: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
    titleModal: PropTypes.string,
    checkbox: PropTypes.bool,
    radio: PropTypes.bool,
    create: PropTypes.bool,
    remove: PropTypes.bool,
    icons: PropTypes.bool,
    variant: PropTypes.oneOf(['contained', 'outlined', 'text']),
    showPagination: PropTypes.bool,
    onCallback: PropTypes.func,
    noCreate: PropTypes.bool,
    noRemove: PropTypes.bool,
    onRow: PropTypes.func,
    onOpenForm: PropTypes.func,
    loading: PropTypes.bool,
    userPerfil: PropTypes.object,
};

CustomSelectDataInTable.defaultProps = {
    date: false,
    time: false,
    height: 20,
    size: 'medium',
    title: '',
    showCount: false,
    paginate: 5,
    unique: 'date',
    items: [],
    label: '',
    disablePreviousDate: false,
    disableFutureDate: false,
    initials: [],
    fields: {},
    onField: (value) => value,
    schema: {},
    isIgnore: '',
    position: 'column',
    maxWidth: 'md',
    titleModal: '',
    checkbox: true,
    radio: false,
    create: true,
    remove: true,
    icons: true,
    variant: 'outlined',
    showPagination: true,
    onCallback: (value) => value,
    noCreate: false,
    noRemove: false,
    onRow: () => undefined,
    onOpenForm: () => undefined,
    loading: false,
};
